// Shared status / option enums for the Catalog page.
// Extracted from the monolithic Videos.jsx so subcomponents can import once.

export const EDIT_OPTIONS = [
  { v: "edited",         label: "✅ Edited" },
  { v: "edit_now",       label: "🔴 Edit now" },
  { v: "semi_edited",    label: "🟠 Semi-edited" },
  { v: "pending",        label: "🟠 Pending" },
  { v: "needs_re_edit",  label: "🔄 Needs Re-Edit" },
  { v: "reedited",       label: "✨ Re-Edited" },
  { v: "no_publishing",  label: "🚫 No publishing" },
];

export const PPV_OPTIONS = [
  { v: "none",      label: "—" },
  { v: "presale",   label: "🟡 Presale" },
  { v: "sale",      label: "💰 Sale" },
  { v: "live_sub",  label: "✅ Live Sub" },
  { v: "scheduled", label: "📅 Scheduled" },
];

// Extended options for user-added platforms (Faphouse / Top4Fans / ManyVids style)
export const EXTRA_PPV_OPTIONS = [
  { v: "none",           label: "—" },
  { v: "to_be_published", label: "📝 To be published" },
  { v: "scheduled",      label: "📅 Scheduled" },
  { v: "published",      label: "✅ Published" },
  { v: "one_time_sale",  label: "💰 One-time sale" },
  { v: "sold",           label: "💸 Sold" },
  { v: "live_sub",       label: "🔓 Live sub" },
];

export const OF_FREE_OPTIONS = [
  { v: "none",         label: "—" },
  { v: "preview_only", label: "👁 Preview only" },
  { v: "locked_paid",  label: "🔒 Locked paid" },
];

export const RFC_OPTIONS = [
  { v: "none",      label: "—" },
  { v: "uploaded",  label: "⬆ Uploaded" },
  { v: "scheduled", label: "📅 Scheduled" },
  { v: "published", label: "✅ Published" },
];
